import React from 'react'
import Seasons from './Seasons'

function Season() {
  return (
    <>
    <Seasons />
    </>
  )
}

export default Season